// extracted by mini-css-extract-plugin
export default {"modal":"PurchaseSuccess_modal__KK-i6","title":"PurchaseSuccess_title__SYjdv","button":"PurchaseSuccess_button__mfwS3"};